<section #sectionRef class="critical-freight-section">
  <div class="critical-freight-section__title">
    <span class="critical-freight-section__title-label">{{
      'landing.criticalFreight.label' | translate
    }}</span>
    <h2 class="critical-freight-section__title-title">
      {{ 'landing.criticalFreight.title' | translate }}
    </h2>
    <p class="critical-freight-section__title-subtitle">
      {{ 'landing.criticalFreight.subtitle' | translate }}
    </p>
  </div>

  <div class="critical-freight-section__road">
    <div class="critical-freight-section__road-line">
      <div class="critical-freight-section__road-line-done" [style.width]="progressWidth()"></div>

      <div
        class="critical-freight-section__road-line-item critical-freight-section__road-line-item--1"
      >
        <fr8bot-ui-icon name="web-progress-checkmark" [size]="40" />

        <span class="critical-freight-section__road-line-item-text">{{
          'landing.criticalFreight.steps.shipmentDetails' | translate
        }}</span>
      </div>

      <div
        class="critical-freight-section__road-line-item critical-freight-section__road-line-item--2"
      >
        <fr8bot-ui-icon
          [name]="isStepTwoDone() ? 'web-progress-checkmark' : 'web-progress-empty'"
          [size]="40"
        />

        <span class="critical-freight-section__road-line-item-text">{{
          'landing.criticalFreight.steps.selectDriver' | translate
        }}</span>
      </div>

      <div
        class="critical-freight-section__road-line-item critical-freight-section__road-line-item--4"
      >
        <fr8bot-ui-icon
          [name]="isStepThreeDone() ? 'web-progress-checkmark' : 'web-progress-empty'"
          [size]="40"
        />

        <span class="critical-freight-section__road-line-item-text">
          {{ 'landing.criticalFreight.steps.pickUp' | translate }}
        </span>
      </div>

      <div
        class="critical-freight-section__road-line-item critical-freight-section__road-line-item--van"
        [style.left]="vanLeft()"
      >
        <fr8bot-ui-icon name="web-progress-van" [size]="50" />
      </div>

      <div
        class="critical-freight-section__road-line-item critical-freight-section__road-line-item--3"
      >
        <fr8bot-ui-icon name="web-progress-empty" [size]="40" />

        <span class="critical-freight-section__road-line-item-text">{{
          'landing.criticalFreight.steps.delivery' | translate
        }}</span>
      </div>
    </div>
  </div>

  <div class="critical-freight-section__cards-viewport">
    <div #cardsTrackRef class="critical-freight-section__cards">
      <fr8bot-web-critical-freight-card
        [number]="1"
        [title]="'landing.criticalFreight.cards.step1.title' | translate"
        [description]="'landing.criticalFreight.cards.step1.description' | translate"
      />

      <fr8bot-web-critical-freight-card
        [number]="2"
        [title]="'landing.criticalFreight.cards.step2.title' | translate"
        [description]="'landing.criticalFreight.cards.step2.description' | translate"
      />

      <fr8bot-web-critical-freight-card
        [number]="3"
        [title]="'landing.criticalFreight.cards.step3.title' | translate"
        [description]="'landing.criticalFreight.cards.step3.description' | translate"
      />
    </div>
  </div>

  <div class="critical-freight-section__action">
    <fr8bot-ui-button
      type="primaryCut"
      size="large"
      class="critical-freight-section__action-button"
      data-testid="landing-critical-freight-ship-now"
      (click)="shipNow.emit()"
    >
      {{ 'landing.criticalFreight.button' | translate }}
      <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
    </fr8bot-ui-button>
  </div>
</section>
